import { useMemo } from 'react';

import { AddressForm } from '../../../../address/address-form';

import type { AddressFormReferenceData } from '../../../../address/address-form';
import type { Address, State } from '../../../../types/reference-data';
import type { FreightBrowserDestination } from '../../freight-browser-types';

type ShipToSectionProps = {
  value: FreightBrowserDestination;
  onChange: (next: FreightBrowserDestination) => void;
  states: State[];
};

const HIDDEN_FIELDS = ['name', 'company', 'country', 'line1', 'line2', 'line3', 'phone', 'email'] as const;

export const ShipToSection = ({ value, onChange, states }: ShipToSectionProps) => {
  const referenceData = useMemo(
    (): AddressFormReferenceData => ({
      countries: [],
      states,
      isLoadingCountries: false,
      isLoadingStates: false,
      sellerHomeCountry: 'US',
    }),
    [states],
  );

  const handleChange = (next: Partial<Address>) =>
    onChange({ city: next.city ?? '', state: next.state ?? '', postalCode: next.postalCode ?? '', countryCode: next.countryCode ?? 'US' });

  return (
    <AddressForm
      countryCode='US'
      hiddenFields={HIDDEN_FIELDS}
      onChange={handleChange}
      referenceData={referenceData}
      showAddressLine3={false}
      value={value}
    />
  );
};
